/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const FacetButton = ({ onClick, facetValue, activity, type, classNames }) => {
	const { id, count, label: activityLabel } = activity;
	const [ariaLabel, setAriaLabel] = useState('');
	const labels = useLabels();
	const vehicleLabel = labels.get('VEHICLE');
	const vehiclesLabel = labels.get('VEHICLES');
	const label = labels.get(activityLabel);

	useEffect(() => {
		const textLabel = `${label} ${count} ${
			count === 1 ? vehicleLabel : vehiclesLabel
		}`;
		setAriaLabel(textLabel);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [count]);

	// onClick handler is set up to reduce lag + address first option select bug
	// There is a warning being thrown when input has no onChange, so readOnly has been used.
	// readOnly will not affect ability to click since the onClick handler assigns the value not the click itself

	return (
		<li className={classNames}>
			<label htmlFor={`mycars-select-option-${id}`}>
				<input
					id={`mycars-select-option-${id}`}
					name="mycars-select-option"
					onChange={() => onClick(id)}
					type={type}
					value={id}
					checked={facetValue === id}
					aria-label={ariaLabel}
					readOnly
				/>

				<span className="facet-list-facet-label-text-container">
					<span
						role="button"
						className="facet-list-facet-label-text"
						onClick={type === 'radio' ? () => onClick(id) : null}
						tabIndex={-1}
					>
						{label}
						<small className="ddc-font-size-xsmall">
							&#xFEFF; {count}
						</small>
					</span>
				</span>
			</label>
		</li>
	);
};

FacetButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	classNames: PropTypes.string,
	facetValue: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	activity: PropTypes.shape({
		id: PropTypes.string,
		count: PropTypes.number,
		label: PropTypes.string
	}).isRequired
};

export default FacetButton;
